// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"43edd195","710":"acce318f","983":"f1008908"}[chunkId] + ".chunk.js";
};